module.exports = {
  REACT_APP_API_ENDPOINT: 'https://stagingapi.honeyguideapps.com',
  REACT_APP_ASSET_URL: 'https://s3.amazonaws.com/honeyguide/assets',
  REACT_APP_FIREBASE_AUTH_DOMAIN: 'honeyguidedev.firebaseapp.com',
  REACT_APP_FIREBASE_DATABASE_URL: 'https://honeyguidedev.firebaseio.com',
  REACT_APP_FIREBASE_PROJECT_ID: 'honeyguidedev',
  REACT_APP_FIREBASE_STORAGE_BUCKET: 'honeyguidedev.appspot.com',
  REACT_APP_TAWK_ID: '5c57d5ea6cb1ff3c14cafc9c',
};



// WEBPACK FOOTER //
// ./src/config/config.development.js